import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SharedTools from '../../lib/SharedTools';
import DataService from '../../lib/DataService';
import ImageViewModal from '../share/ImageViewModal';

import { Modal, message } from 'antd';

export default class StudentPost extends React.Component {
  static propTypes = {
    post: PropTypes.object.isRequired,
    onUntagPost: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      post: props.post,
      userRoleInfo: props.userRoleInfo,

      isShowDeletePostDialog: false,
      isShowPhotosDialog: false,
      isDeleting: false,
      photoIndex: 0,
    };
    // bind this
    this.getChineseMonth = this.getChineseMonth.bind(this);
    this.toggleOpenDeletePostDialog = this.toggleOpenDeletePostDialog.bind(this);
    this.toggleOpenPhotosDialog = this.toggleOpenPhotosDialog.bind(this);
    this.onDestroyPost = this.onDestroyPost.bind(this);
  }

  componentDidMount() {
    if (this.state.post.video) {
      var element = ReactDOM.findDOMNode(this.videoObj);
      element.setAttribute('controlsList', 'nodownload');
    }else {
      this.state.post.photos = this.state.post.photos.filter(function(photo){
        return photo.tag_id
      })
      this.setState({post: this.state.post})
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      post: newProps.post,
      userRoleInfo: newProps.userRoleInfo
    });
  }

  // Tools
  getChineseMonth(month) {
    let monthNameMap = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'];
    return (month > 0 && month <= 12) ? `${monthNameMap[month]}月` : '';
  }

  // Events
  toggleOpenDeletePostDialog() {
    this.setState({
      isShowDeletePostDialog: !this.state.isShowDeletePostDialog
    })
  }

  onDestroyPost() {
    this.setState({isDeleting: true});
    if (this.state.userRoleInfo && this.state.userRoleInfo.id === this.state.post.author_id)
      DataService.destroyPost(this.state.post.id).then((response) => {
        this.setState({isDeleting: false, isShowDeletePostDialog: false});
        // call parent component to update view
        this.props.onDestroyPost(this.state.post.id);
      }, (error) => {
        message.error('删除新鲜事失败');
        this.setState({isDeleting: false, isShowDeletePostDialog: false});
      });
  }

  toggleOpenPhotosDialog(e) {
    let photoIndex;
    if(e) {
      photoIndex = parseInt(e.currentTarget.dataset.index);
      if(e.currentTarget.dataset.photos) {
        this.state.post.photos = JSON.parse(e.currentTarget.dataset.photos)
      }
    }
    this.setState({
      isShowPhotosDialog: !this.state.isShowPhotosDialog,
      photoIndex: photoIndex,
      post: this.state.post
    })
  }

  // View
  render() {
    let post = this.state.post;
    let recordDate = SharedTools.strToDate(this.state.post.record_date);
    return (
      <div className="student-post-container">
        <div className="record-date">
          <div className="month">{this.getChineseMonth(recordDate.getMonth() + 1)}</div>
          <div className="day">{SharedTools.formatNumber(recordDate.getDate())}</div>
        </div>

        <div className="content">
          <div className="text">{post.text}</div>

          {post.photos && post.photos.length === 1 &&
            <div className="single-photo-container">
              <img className="photo" src={SharedTools.getMediumImageUrl(post.photos[0].remote_url)} onClick={this.toggleOpenPhotosDialog} data-index={0} />
            </div>
          }
          {post.photos && post.photos.length > 1 && post.photos.map((photo, index) =>
            <div key={photo.id} className={"photo-container" + ([5, 6, 9].indexOf(post.photos.length) < 0 && index % 4 == 3 ? " no-right-margin" : "")}>
              <img className="photo" src={SharedTools.getThumbImageUrl(photo.remote_url)} onClick={this.toggleOpenPhotosDialog} data-index={index} />
            </div>
          )}
          {post.video &&
            <video ref={(video) => {this.videoObj = video;}}
              height="220" controls>
              <source src={post.video.remote_url} type="video/mp4" />
              你的浏览器不支持播放视频
            </video>
          }
        </div>

        {this.state.userRoleInfo && this.state.userRoleInfo.id === post.author_id &&
          <div className="actions">
            <div className="three-bullets"></div>
            <div className="menu-container">
              <div className="menu">
                <div className="item"  style={{display: 'none'}}>编辑</div>
                <div className="item" onClick={this.toggleOpenDeletePostDialog}>删除</div>
              </div>
            </div>
          </div>
        }

        <Modal title="删除新鲜事"
          visible={this.state.isShowDeletePostDialog}
          onOk={this.onDestroyPost}
          confirmLoading={this.state.isDeleting}
          onCancel={this.toggleOpenDeletePostDialog}
        >
          <p>删除内容后新鲜事也一并从相册中消失</p>
        </Modal>

        {this.state.isShowPhotosDialog &&
          <ImageViewModal type="record" postId={this.state.post.id} userRoleInfo={this.state.userRoleInfo} photos={this.state.post.photos} photoIndex={this.state.photoIndex} onCancel={this.toggleOpenPhotosDialog} onUntagPost={this.props.onUntagPost} />
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/album/StudentPost.jsx